const apisettings = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  REACT_APP_ENV: process.env.REACT_APP_ENV
}


export default apisettings;
